import React from "react"
import { useConfirmation } from "@/hooks/use-confirmation"
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog"

export function ConfirmationDialogProvider() {
  const { confirmations } = useConfirmation()

  return (
    <>
      {confirmations.map((confirmation) => (
        <AlertDialog
          key={confirmation.id}
          open={confirmation.open}
          onOpenChange={(open) => {
            if (!open) {
              confirmation.onCancel?.()
            }
          }}
        >
          <AlertDialogContent>
            <AlertDialogHeader>
              <AlertDialogTitle>{confirmation.title}</AlertDialogTitle>
              <AlertDialogDescription>
                {typeof confirmation.description === 'string' ? (
                  confirmation.description
                ) : (
                  <div className="text-sm text-muted-foreground">
                    {confirmation.description}
                  </div>
                )}
              </AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter className="gap-2">
              <AlertDialogCancel onClick={confirmation.onCancel}>
                {confirmation.cancelText || "Cancel"}
              </AlertDialogCancel>
              {confirmation.onAlternative && (
                <AlertDialogAction
                  onClick={confirmation.onAlternative}
                  className="bg-orange-600 text-secondary-foreground hover:bg-orange-700 border border-input"
                >
                  {confirmation.alternativeText || "Alternative"}
                </AlertDialogAction>
              )}
              <AlertDialogAction
                onClick={confirmation.onConfirm}
                className={
                  confirmation.variant === "destructive"
                    ? "bg-red-600 hover:bg-red-700 focus:ring-red-500"
                    : ""
                }
              >
                {confirmation.confirmText || "Confirm"}
              </AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
      ))}
    </>
  )
} 